
/* ===== index.html inline @line 274 ===== */

  document.addEventListener('DOMContentLoaded', function () {
    const triggerBlock = document.querySelector('.way_main'); // Блок, от которого считаем прокрутку
    if (!triggerBlock) return;

    // === Определение Safari или iOS ===
    const ua = window.navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    const useCanvas = isIOS || isSafari;

    // === Плавность ===
    const smoothFactor = 0.8;
    let targetFrame = 0;
    let currentFrame = 0;

    let animation = null;
    let container = null;
    let updateFn = null;

    // === Отдельные настройки для моб и десктоп ===
    const config = {
      desktop: {
        selector: '.logo-transform',
        start: 0.1,
        end: 0.92,
        path: (window.BV_ASSETS || '') + 'data.json'
      },
      mobile: {
        selector: '.logo-transform-mob',
        start: -0.1,
        end: 0.3,
        path: (window.BV_ASSETS || '') + 'data.json'
      }
    };

    function initAnimation() {
      const isMobileScreen = window.innerWidth < 480;
      const conf = isMobileScreen ? config.mobile : config.desktop;

      container = document.querySelector(conf.selector);
      if (!container) return;

      // Удаляем старую анимацию
      if (animation) {
        animation.destroy();
        animation = null;
      }

      // Загружаем новую анимацию
      animation = lottie.loadAnimation({
        container: container,
        renderer: useCanvas ? 'canvas' : 'svg',
        loop: false,
        autoplay: false,
        path: conf.path
      });

      animation.addEventListener('DOMLoaded', () => {
        animation.goToAndStop(0, true);
        smoothUpdate();
        updateFn = () => updateTargetFrame(conf.start, conf.end);
        window.addEventListener('scroll', updateFn);
        updateFn(); // при загрузке
      });
    }

    function updateTargetFrame(start, end) {
      if (!animation || !animation.isLoaded) return;

      const rect = triggerBlock.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const blockHeight = rect.height;
      const blockTop = rect.top;
      const totalScroll = windowHeight + blockHeight;
      const scrolled = windowHeight - blockTop;

      let progress = scrolled / totalScroll;
      let range = end - start;
      let relativeProgress = (progress - start) / range;

      relativeProgress = Math.max(0, Math.min(1, relativeProgress));
      targetFrame = relativeProgress * animation.totalFrames;
    }

    function smoothUpdate() {
      currentFrame += (targetFrame - currentFrame) * smoothFactor;
      if (animation) animation.goToAndStop(currentFrame, true);
      requestAnimationFrame(smoothUpdate);
    }

    // Инициализация + пересоздание при ресайзе
    initAnimation();
    window.addEventListener('resize', () => {
      initAnimation();
    });
  });


/* ===== index.html inline @line 374 ===== */

  document.addEventListener('DOMContentLoaded', function () {
    lottie.loadAnimation({
      container: document.querySelector('.man'),
      renderer: 'svg',
      loop: true, // Включаем зацикливание
      autoplay: true,
      path: (window.BV_ASSETS || '') + 'chelovek.json' // Укажи свой путь к JSON
    });
  });


/* ===== index.html inline @line 387 ===== */

  document.addEventListener('DOMContentLoaded', function () {
    // === Кнопки .btn-white ===
    const whiteButtons = document.querySelectorAll('.btn-white');

    whiteButtons.forEach(button => {
      const dotsContainers = button.querySelectorAll('.btn-dots');
      let targetContainer = null;

      dotsContainers.forEach(container => {
        if (container.querySelector('img')) {
          targetContainer = container;
        }
      });

      if (!targetContainer) return;

      // Удаляем изображения
      targetContainer.querySelectorAll('img').forEach(img => img.remove());

      const animContainer = document.createElement('div');
      animContainer.style.width = '100%';
      animContainer.style.height = '100%';
      targetContainer.appendChild(animContainer);

      const anim = lottie.loadAnimation({
        container: animContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: (window.BV_ASSETS || '') + 'knopka_animaciya.json'
      });

      button.addEventListener('mouseenter', () => {
        anim.stop();
        anim.goToAndStop(0, true);
        anim.setDirection(1);
        anim.play();
      });
    });

    // === Кнопки .btn-black ===
    const blackButtons = document.querySelectorAll('.btn-black');

    blackButtons.forEach(button => {
      const targetContainer = button.querySelector('.btn-dots_white');
      if (!targetContainer) return;

      // Удаляем изображения
      targetContainer.querySelectorAll('img').forEach(img => img.remove());

      const animContainer = document.createElement('div');
      animContainer.style.width = '100%';
      animContainer.style.height = '100%';
      targetContainer.appendChild(animContainer);

      const anim = lottie.loadAnimation({
        container: animContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: (window.BV_ASSETS || '') + 'knopka_animaciya.json'
      });

      button.addEventListener('mouseenter', () => {
        anim.stop();
        anim.goToAndStop(0, true);
        anim.setDirection(1);
        anim.play();
      });
    });
  });


/* ===== index.html inline @line 1504 ===== */

(function(){
  var section=document.getElementById('logo-portfolio');
  if(!section)return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lines=section.querySelectorAll('.bv-portfolio-title-line');
  lines.forEach(function(line,lineIndex){
    var text=line.textContent;
    line.textContent='';
    Array.from(text).forEach(function(character,index){
      var span=document.createElement('span');
      span.className='bv-portfolio-title-char';
      span.textContent=character===' '?String.fromCharCode(160):character;
      span.style.transitionDelay=(.08+((index*7+lineIndex*5)%13)*.035)+'s';
      line.appendChild(span);
    });
  });
  var delays=['0s','.12s','.28s','.42s','.56s'];
  section.querySelectorAll('.bv-portfolio-reveal').forEach(function(element,index){element.style.setProperty('--bv-delay',delays[index]||'.56s');});
  if(!reduced&&'IntersectionObserver'in window){
    section.classList.add('bv-motion-ready');
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting){section.classList.add('bv-in-view');observer.disconnect();}});
    },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
    observer.observe(section);
  }else{
    section.classList.add('bv-in-view');
  }
  var orbit=section.querySelector('.bv-portfolio-orbit');
  var core=section.querySelector('.bv-portfolio-core');
  if(orbit&&core&&window.matchMedia('(hover:hover) and (pointer:fine)').matches&&!reduced){
    orbit.addEventListener('pointermove',function(event){
      var rect=orbit.getBoundingClientRect();
      var x=((event.clientX-rect.left)/rect.width-.5)*12;
      var y=((event.clientY-rect.top)/rect.height-.5)*12;
      core.style.transform='translate('+x+'px,'+y+'px)';
    });
    orbit.addEventListener('pointerleave',function(){core.style.transform='translate(0,0)';});
  }
})();
